<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('team_add') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                <form ref="form" data-url="/our-team/store" class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('name') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.name"
                                   :required="true"
                                   :placeholder="$t('name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('designation') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.designation"
                                   :placeholder="$t('designation_name')"/>
                    </div>
                    <div class="form-group row">
                        <label for="inputs_editor" class="col-sm-2 h-fit-content">
                            {{ $t('about') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="text-editor"
                                       :required="false"
                                       id="text-editor-id"
                                       :label="$t('message_placeholder')" v-model="reqData.about"/>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="number_input" class="col-sm-2 mb-sm-0">
                            {{ $t('order_on') }}
                        </label>
                        <app-input id="number_input"
                                   class="col-sm-8"
                                   type="number"
                                   v-model="reqData.order_on"
                                   :placeholder="$t('number_type_input')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('facebook_id') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.facebook_id"
                                   :required="false"
                                   :placeholder="$t('facebook_id_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('linkedin_id') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.linkedin_id"
                                   :required="false"
                                   :placeholder="$t('linkedin_id_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('twitter_id') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.twitter_id"
                                   :required="false"
                                   :placeholder="$t('twitter_id_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_keyword') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.meta_keyword"
                                   :required="false"
                                   :placeholder="$t('meta_key_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.meta_title"
                                   :required="false"
                                   :placeholder="$t('meta_title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_description') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="textarea"
                                   v-model="reqData.meta_description"
                                   :required="false"
                                   :placeholder="$t('meta_description_name')"/>
                    </div> 

                    <div class="form-group row">
                        <label for="teamThumbImage" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                            {{ $t('upload_thumb_image') }}<br>
                            <small class="text-muted font-italic">
                                {{ $t('recommended_team_thumb_size') }}
                            </small>
                        </label>
                        <div class="col-lg-8 col-xl-8">
                            <app-input id="teamThumbImage"
                                       type="custom-file-upload"
                                       :generate-file-url="false"
                                       v-model="reqData.thumb_image"
                                       :label="$t('upload_your_thumb_file')"/>
                        </div>
                    </div> 

                    <div class="form-group row">
                        <label for="teamFeaturedImage" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                            {{ $t('upload_image') }}<br>
                            <small class="text-muted font-italic">
                                {{ $t('recommended_team_featured_size') }}
                            </small>
                        </label>
                        <div class="col-lg-8 col-xl-8">
                            <app-input id="teamFeaturedImage"
                                       type="custom-file-upload"
                                       :generate-file-url="false"
                                       v-model="reqData.featured_image"
                                       :label="$t('upload_your_file')"/>
                        </div>
                    </div> 

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="reqData.status"
                                       :required="false"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('profile') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="checkboxLists"
                                       v-model="reqData.featured"
                                       :required="false"/>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    export default {
        name: "FormLayouts",
        mixins: [FormMixin],
        props: ['categories'],
        data() {
             return {
                preloader: false,
                reqData: {
                    name: '',
                    designation: '',                    
                    about: '',
                    facebook_id: '',
                    linkedin_id: '',
                    twitter_id: '',
                    meta_keyword: '',
                    meta_title: '',
                    meta_description: '',
                    thumb_image: '',
                    featured_image: '',
                    status: 'active',
                    featured: '0',

                },
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ],
                checkboxLists: [
                    {id: '1', value: "Yes"},
                    {id: '0', value: "No"}
                ]
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.reqData)) {                    
                    if (value != null) formData.append(key, value);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.reqData = {
                    status: 'active',
                    about: '',
                    featured: '0',
                };
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.reqData = {
                    status: 'active',
                    about: '',
                    featured: '0',
                };
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }

    }
</script>
